module.exports = __webpack_public_path__ + "stylesheets/section-video-time_79a7377d61a460bc3661f68cf7d54506.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-video-time.less
// module id = t/nL
// module chunks = 118